import { environmentConfig, isDevelopmentNodeEnvironment } from "@src/appV2/environment";
import { isCapacitorPlatform } from "@src/appV2/lib/utils/capacitor/platformUtils";

export const getAppUrl = (): string => {
  const isDevelopment =
    isDevelopmentNodeEnvironment() || globalThis.location.hostname === "localhost";

  if (isCapacitorPlatform()) {
    return environmentConfig.REACT_APP_WEB_APP_URL;
  }

  if (isDevelopment) {
    return `http://localhost:4300`;
  }

  const { hostname, pathname } = globalThis.location;
  if (hostname.endsWith("cloudfront.net")) {
    const match = /^\/pr-\d+\//.exec(pathname);
    if (match) {
      const strippedPathname = match[0].slice(0, -1);
      return `https://${hostname}${strippedPathname}`;
    }
  }

  return `https://${hostname}`;
};
